import { useAppConfig } from "@fdoh/health-ui-react";
import { IConfig } from "@fdoh/health-ui-react/build/ts/types";

export interface IPrivateProviderInspectionSettings extends IConfig {
    driveId: string;
    appGuid: string;
    appName: string;
}

export const useAppSettings = () => {
  const config = useAppConfig();
    return config as IPrivateProviderInspectionSettings;
};

export default useAppSettings;
